import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiContext } from 'react-easyrocket';
import { LogoApp } from 'src/config/components/LogoApp';
import { isPwa } from 'src/constants';
import { CloseComponentWithoutStyles } from 'src/svg/Closes';
import { Download } from 'src/svg/Downloads';
import { useSettings } from 'src/modules/settings';
import { DAY } from 'src/constants/timeMeasures';
import { useDrawer } from 'src/hooks/useDrawer';

export const PwaPopup: FC = () => {
  const { t } = useTranslation();
  const { closeDrawer } = useDrawer();
  const {
    pwa: { promptPwaPopup, isPwaPopupVisible, showPwaPopup, hidePwaPopup }
  } = useSettings();
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (isPwa) return;
    const lastClose = localStorage.getItem('timeHideMobilePopup');
    if (!lastClose || Number(lastClose) > Date.now() + DAY) {
      showPwaPopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const handleInstallClick = () => {
    closeDrawer();
    promptPwaPopup();
    hidePwaPopup();
  };

  const handleCloseClick = (e: MouseEvent) => {
    e.stopPropagation();
    localStorage.setItem('timeHideMobilePopup', `${Date.now()}`);
    hidePwaPopup();
  };

  if (!isPwaPopupVisible) return null;

  return (
    <div
      className="top-0 bg-cbadge_bg px-2.5 py-[5px] text-mobap_text cursor-pointer items-center left-0 bottom-0 right-0 w-full h-auto z-[1000] flex justify-between gap-2 768:hidden"
      onClick={handleInstallClick}>
      <div className="rounded-[10px]">
        <LogoApp className="w-10 h-10" />
      </div>

      <div className="flex gap-2.5 items-center text-sm font-bold text-cbadge_text">
        <Download fill="var(--mobap_bg)" className="w-[30px] h-[30px]" />
        {t('general.pwaInstall')}
      </div>

      <CloseComponentWithoutStyles fill="var(--mobap_bg)" onShow={handleCloseClick} />
    </div>
  );
};
